import { SYNTAX_REGEX } from '~/constants';

function makeRegexRuleCallback(regex: RegExp): (value: string) => boolean {
  return (value: string) => regex.test(value);
}

export const telRuleCallback = makeRegexRuleCallback(SYNTAX_REGEX.tel);

export const numberRuleCallback = makeRegexRuleCallback(SYNTAX_REGEX.number);

export const emailRuleCallback = makeRegexRuleCallback(SYNTAX_REGEX.email);

export const urlRuleCallback = makeRegexRuleCallback(SYNTAX_REGEX.url);

export function registerTelephoneRule(validator, msg = 'Invalid telephone format') {
  validator.register('telephone', telRuleCallback, msg);
}

export function registerNumberRule(validator, msg = 'Invalid number format') {
  validator.register('number', numberRuleCallback, msg);
}

export function registerEmailRule(validator, msg = 'Invalid email format') {
  validator.register('email', emailRuleCallback, msg);
}

export function registerUrlRule(validator, msg = 'Invalid url format') {
  validator.register('url', urlRuleCallback, msg);
}
